import {
    displayShortDateOrNA,
    displayPercentOrNaTruthyZero
} from '../../utils/Format/Format';
// import { tipsFunds } from '../../utils/fund-info';

// TODO: replace with centralized inflation volatility utils
// let standardYield30DayStandard;
// let standardUnsubsidizedThirtyDaySECYield;
// export const theCompareTickerFunc = (
//     yield30DayStandard,
//     unsubsidizedThirtyDaySECYield
// ) => {
//     standardYield30DayStandard = yield30DayStandard * 1.25;
//     standardUnsubsidizedThirtyDaySECYield =
//         unsubsidizedThirtyDaySECYield * 1.25;
// };
// export const defaultDisclosure = (ticker) => tipsFunds.includes(ticker);
//
// export const displayDisclosure = (fundYield, unsubsidizedFundYield, ticker) => {
//     const fy =
//         fundYield >= standardYield30DayStandard && tipsFunds.includes(ticker);
//
//     const ufy =
//         unsubsidizedFundYield >= standardUnsubsidizedThirtyDaySECYield &&
//         tipsFunds.includes(ticker);
//     return !fy ? ufy : fy;
// };
// export const displayIcon = (ticker) => tipsFunds.includes(ticker);

export const dayYieldUtil = (
    isMoneyMarket,
    ticker,
    isFI,
    checkInflationVolatility
) => (gqlResult) => {
    if (!gqlResult) return null;

    let asOfDate;
    let title;
    let returnData;
    let yield30Day;
    let unsubsidizedThirtyDay;
    let hasInflationVolatility = false;

    const {
        standardPerformanceReturns,
        averageAnnualTotalReturns = {}
    } = gqlResult.fund;

    const quarterlyAnnualReturns =
        standardPerformanceReturns?.quarterlyAnnualReturns?.fundPerformance;
    const quarterlyData =
        quarterlyAnnualReturns || averageAnnualTotalReturns.quarterly;

    const { asOfDate: quarterlyDate } = quarterlyData || {};

    if (isMoneyMarket) {
        const {
            sevenDayYieldSimple,
            sevenDayYieldSimpleAsOfDate,
            unsubsidizedSevenDayYieldSimple
        } = gqlResult.fund;

        asOfDate = sevenDayYieldSimpleAsOfDate;
        title = `7-Day SEC Yield`;
        returnData = [
            {
                label: `w/Waiver`,
                values: [
                    { val: displayPercentOrNaTruthyZero(sevenDayYieldSimple) }
                ]
            },
            {
                label: `w/o Waiver`,
                values: [
                    {
                        val: displayPercentOrNaTruthyZero(
                            unsubsidizedSevenDayYieldSimple
                        )
                    }
                ]
            }
        ];
    } else {
        const {
            fund: {
                thirtyDayAnnualizedDividendYieldAsOfDate: annualDividendAsOfDate,
                thirtyDayAnnualizedDividendYield,
                yield30DayStandardEffectiveDate: yieldThirtyDatStandardAsOfDate,
                yield30DayStandard,
                thirtyDaySECDividend,
                unsubsidizedThirtyDaySECYieldAsOfDate: secYieldAsOfDate,
                unsubsidizedThirtyDaySECYield,
                thirtyDaySECDividendAsOfDate
            }
        } = gqlResult;

        hasInflationVolatility = checkInflationVolatility(
            yield30DayStandard,
            unsubsidizedThirtyDaySECYield,
            ticker
        );

        yield30Day = yield30DayStandard;
        unsubsidizedThirtyDay = unsubsidizedThirtyDaySECYield;
        title = `30-Day Yield`;

        const returnDataReg = [
            {
                label: `Annualized Dividend as of (${displayShortDateOrNA(
                    annualDividendAsOfDate
                )})`,
                values: [
                    {
                        /*
                        * @ref: US101651
                        * @note: should only show ann. dividend if
                        * sec stand w/waiver OR w/o waiver are defined
                        */
                        val1: displayPercentOrNaTruthyZero(
                            (yield30DayStandard ||
                                unsubsidizedThirtyDaySECYield) &&
                                thirtyDayAnnualizedDividendYield
                        )
                    }
                ],
                id: 'annualized-dividend-row'
            },
            {
                label: `SEC Standardized w/Waiver as of (${displayShortDateOrNA(
                    yieldThirtyDatStandardAsOfDate
                )})`,
                values: [
                    { val1: displayPercentOrNaTruthyZero(yield30DayStandard) }
                ],
                id: 'sec-with-waiver-row',
                yieldSup: hasInflationVolatility
            },
            {
                label: `SEC Standardized w/o Waiver as of (${displayShortDateOrNA(
                    secYieldAsOfDate
                )})`,
                values: [
                    {
                        val1: displayPercentOrNaTruthyZero(
                            unsubsidizedThirtyDaySECYield
                        )
                    }
                ],
                id: 'sec-without-waiver-row',
                yieldSup: hasInflationVolatility
            }
        ];

        const returnDataFI = [
            {
                label: `SEC Standardized w/Waiver as of (${displayShortDateOrNA(
                    thirtyDaySECDividendAsOfDate
                )})`,
                values: [
                    { val1: displayPercentOrNaTruthyZero(thirtyDaySECDividend) }
                ],
                id: 'sec-with-waiver-row'
            },
            {
                label: `SEC Standardized w/o Waiver as of (${displayShortDateOrNA(
                    secYieldAsOfDate
                )})`,
                values: [
                    {
                        val1: displayPercentOrNaTruthyZero(
                            unsubsidizedThirtyDaySECYield
                        )
                    }
                ],
                id: 'sec-without-waiver-row'
            }
        ];

        returnData = isFI ? returnDataFI : returnDataReg;
    }

    const headers = [
        `${title}`,
        asOfDate ? `As of ${displayShortDateOrNA(asOfDate)}` : ''
    ];

    return {
        data: returnData,
        headers,
        yield30Day,
        unsubsidizedThirtyDay,
        quarterlyDate,
        hasInflationVolatility
    };
};
